<template>
  <div :class="{ 'vm-sidebar-close': sidebarCollapsed }" class="vm-sidebar">
    <el-scrollbar>
      <div class="logo">
        <el-badge value="">
          <!--          <div>MES</div>-->
          <div><img width="179" height="50" :src="logoSrc"></div>
        </el-badge>
      </div>
      <div class="menuSearch">
        <el-input
            v-model="menuName"
            placeholder="搜索"
            prefix-icon="el-icon-search"
            clearable
            @input="inputHandle"/>
      </div>
      <transition>
        <el-menu :default-openeds="defaultOpens" :collapse="sidebarCollapsed" :default-active="$route.path"
                 active-text-color="#fff">
          <sidebar-item v-for="menu in authMenus" :key="menu.menuName" :item="menu"
                        :sidebar-collapsed="sidebarCollapsed"/>
        </el-menu>
      </transition>
    </el-scrollbar>
  </div>
</template>

<script>
import SidebarItem from "./SidebarItem";

export default {
  components: {SidebarItem},
  props: {
    sidebarCollapsed: Boolean,
  },
  data() {
    return {
      logoSrc: "",
      menuName: "",
      menusCopy: "",
      defaultOpens: [],
      menus: [
        {
          menuName: "工作流",
          code: "workFlow",
          level: 1,
          children: [
            {
              menuName: "销售订单待办",
              path: "/workFlow/SalesOrderApplication",
              code: "SalesOrderApplication:query",
              level: 2,
              authIndex: 316,
            },
            {
              menuName: "发货通知单",
              path: "/workFlow/DeliveryNoteApplication",
              code: "DeliveryNoteApplication:query",
              level: 2,
              authIndex: 475,
            },
            {
              menuName: "商务申请",
              path: "/workFlow/BusinessApplication",
              code: "BusinessApplication:query",
              level: 2,
              authIndex: 3,
            },
            {
              menuName: "ESOP变更申请",
              path: "/workFlow/EsopFileApplication",
              code: "EsopFileApplication:query",
              level: 2,
              authIndex: 400,
            },
            {
              menuName: "客诉申请待办",
              path: "/workFlow/ReplacementBillApplication",
              code: "WfReplacementBillApplication:query",
              level: 2,
              authIndex: 608,
            },
            {
              menuName: "新产品申请待办",
              path: "/workFlow/ProductionApplication",
              code: "ProductionApplication:query",
              level: 2,
              authIndex: 613,
            },
            {
              menuName: "来料NG待办",
              path: "/workFlow/PurchaseNgApplication",
              code: "PurchaseNgApplication:query",
              level: 2,
              authIndex: 618,
            },
            {
              menuName: "首检巡检NG待办",
              path: "/workFlow/ProductNgApplication",
              code: "ProductNgApplication:query",
              level: 2,
              authIndex: 623,
            },
            {
              menuName: "供应商申请待办",
              path: "/workFlow/SupplierApplication",
              code: "SupplierApplication:query",
              level: 2,
              authIndex: 652,
            },
          ],
        },
        {
          menuName: "销售管理",
          code: "salesManage",
          level: 1,
          children: [
            {
              menuName: "商务申请",
              path: "/SalesManage/businessApplication/BusinessApplicationList",
              code: "businessApplication:query",
              level: 2,
              authIndex: 301,
            },
            {
              menuName: "销售订单",
              path: "/SalesManage/SalesOrder/SalesOrderList",
              code: "salesOrder:query",
              level: 2,
              authIndex: 3,
            },
            {
              menuName: "销售订单明细",
              path: "/SalesManage/SalesOrder/SalesOrderDetailList",
              code: "salesOrder:query",
              level: 2,
              authIndex: 242,
            },
            {
              menuName: "客户采购订单",
              path: "/SalesManage/CustomerPurchaseOrder/CustomerPurchaseOrderList",
              code: "customerPurchaseOrder:query",
              level: 2,
              authIndex: 321,
            },
            {
              menuName: "销售订单待发货",
              path: "/SalesManage/SalesOrder/SalesOrderDetailUnDeliveryList",
              code: "SalesOrderDetailUnDelivery:query",
              level: 2,
              authIndex: 242,
            },
          ],
        },
        {
          menuName: "统计分析",
          code: "ReportManagement",
          level: 1,
          children: [
            {
              menuName: "客户销售发货报表",
              path: "/Report/SalesReport/CustomerSalesReport",
              code: "salesReport:query",
              level: 2,
              authIndex: 466,
            },
            {
              menuName: "工单准时率报表",
              path: "/Report/ProductReport/WorkOrderPunctualityReport",
              code: "ProductReport:query",
              level: 2,
              authIndex: 467,
            },
            {
              menuName: "检验准时率报表",
              path: "/Report/InspectionRpt/InspectionRpt",
              code: "InspectionRpt:query",
              level: 2,
              authIndex: 468,
            },
            {
              menuName: "采购准时率报表",
              path: "/Report/PurchaseRpt/PurchasePunctualityReport",
              code: "PurchaseRpt:query",
              level: 2,
              authIndex: 469,
            },
            {
              menuName: "产线节点报表",
              path: "/Report/ProcessRpt/ProcessRpt",
              code: "ProcessRpt:query",
              level: 2,
              authIndex: 486,
            },
            {
              menuName: "产线时间明细报表",
              path: "/Report/ProcessRpt/ProcessDetailRpt",
              code: "ProcessDetailRpt:query",
              level: 2,
              authIndex: 488,
            },
            {
              menuName: "仓库收发料报表",
              path: "/Report/StockRpt/StockRpt",
              code: "StockRpt:query",
              level: 2,
              authIndex: 487,
            },
          ],
        },
        {
          menuName: "文档管理",
          code: "FileManagement",
          level: 1,
          children: [
            {
              menuName: "文档管理",
              path: "/information/FileManagement/FileManageList",
              code: "FileManage:query",
              level: 2,
              authIndex: 510,
            },
            {
              menuName: "ESOP管理",
              path: "/information/Esop/EsopList",
              code: "Esop:query",
              level: 2,
              authIndex: 192,
            },
            {
              menuName: "ESOP变更管理",
              path: "/information/EsopChange/EsopChangeList",
              code: "EsopChange:query",
              level: 2,
              authIndex: 504,
            },
          ],
        },
        {
          menuName: "生产管理",
          code: "ProductionManagement",
          level: 1,
          children: [
            {
              menuName: "生产工单",
              path: "/ProductionManagement/ProductionPlan/ProductionPlanList",
              code: "ProductionBatch:query",
              level: 2,
              authIndex: 12,
            },
            {
              menuName: "生产排产",
              path: "/ProductionManagement/ProductionOrder/ProductionOrderList",
              code: "ProductionOrder:query",
              level: 2,
              authIndex: 18,
            },
            {
              menuName: "生产任务",
              path: "/ProductionManagement/ProductionTask/ProductionTaskList",
              code: "ProductionTask:query",
              level: 2,
              authIndex: 359,
            },
            {
              menuName: "生产条码记录",
              path: "/ProductionManagement/ProductionCode/ProductionCodeList",
              code: "ProductionCode:query",
              level: 2,
              authIndex: 359,
            },
            {
              menuName: "扫描工序记录",
              path: "/ProductionManagement/ProductionProcess/ProductionProcessList",
              code: "ProductionProcess:query",
              level: 2,
              authIndex: 359,
            },
            {
              menuName: "生产计划",
              path: "/ProductionManagement/ProductionProject/ProductionProject",
              code: "ProductionProject:query",
              level: 2,
              authIndex: 403,
            },
            {
              menuName: "线边库存明细",
              path: "/ProductionManagement/LineLocation/LineLocationList",
              code: "LineLocation:query",
              level: 2,
            },
          ],
        },
        {
          menuName: "发运管理",
          code: "Delivery",
          level: 1,
          children: [
            // {
            //   menuName: "发货通知单",
            //   path: "/SalesManage/DeliveryNotice/DeliveryNoticeList",
            //   code: "deliveryNotice:query",
            //   level: 2,
            //   authIndex: 292,
            // },
            {
              menuName: "发货通知单明细",
              path: "/SalesManage/DeliveryNotice/DeliveryNoticeDetailList",
              code: "DeliveryNoticeDetail:query",
              level: 2,
              authIndex: 462,
            },
            // {
            //   menuName: "发货通知单待办",
            //   path: "/StoreManagement/UnHandleDelivery/DeliveryNoticeDetailUnHandleList",
            //   code: "DeliveryNoticeDetailUnHandle:query",
            //   level: 2,
            //   authIndex: 482,
            // },
            {
              menuName: "销售出库单待办",
              path: "/DeliveryManage/MmDeliveryDetailUnHandleList",
              code: "MmDeliveryDetailUnHandleList:query",
              level: 2,
              authIndex: 298,
            },
            {
              menuName: "销售出库单",
              path: "/DeliveryManage/MmDeliveryDetailList",
              code: "MmDeliveryDetailList:query",
              level: 2,
              authIndex: 298,
            },
            {
              menuName: "装箱清单",
              path: "/DeliveryManage/PackMark/PackMarkDetailList",
              code: "PackMarkDetailList:query",
              level: 2,
              authIndex: 743,
            },
          ],
        },
        {
          menuName: "售后管理",
          code: "csm",
          level: 1,
          children: [
            {
              menuName: "客诉申请",
              path: "/csm/ReplacementBill/ReplacementBillList",
              code: "ReplacementBillList:query",
              level: 2,
              authIndex: 604,
            },
          ],
        },
        {
          menuName: "标签管理",
          code: "LabelPrinting",
          level: 1,
          children: [
            {
              menuName: "物料标签管理",
              path: "/MaterialLabel/MaterialLabelTabs",
              code: "MaterialLabelPrinting:query",
              level: 2,
              authIndex: [722, 731, 736, 753],
            },
            {
              menuName: "标签打印",
              path: "/LabelPrinting/LabelPrintingPage",
              code: "LabelPrinting:query",
              level: 2,
              authIndex: 382,
            },
            {
              menuName: "初始化标签打印",
              path: "/LabelPrinting/MaterialInitializationLabelPrinting",
              code: "LabelPrinting:query",
              level: 2,
              authIndex: 386,
            },
            {
              menuName: "生产标签打印",
              path: "/LabelPrinting/LabelPrintingPageTaskOrder",
              code: "LabelPrintingPageTaskOrder:query",
              level: 2,
              authIndex: 485,
            },
          ],
        },
        {
          menuName: "采购管理",
          code: "PurchaseManagement",
          level: 1,
          children: [
            {
              menuName: "采购收货",
              path: "/StoreManagement/PurchaseReceiving/PurchaseReceivingIndex",
              code: "PurchaseReceiving:query",
              level: 2,
              authIndex: 58,
            },
            {
              menuName: "采购收货明细",
              path: "/StoreManagement/PurchaseReceivingDetail/PurchaseReceivingDetail",
              code: "PurchaseReceivingDetail:query",
              level: 2,
              authIndex: 93,
            },
            {
              menuName: "采购订单",
              path: "/StoreManagement/PurchaseOrder/PurchaseOrder",
              code: "PurchaseOrder:query",
              level: 2,
              authIndex: 701,
            },
            {
              menuName: "采购订单明细",
              path: "/StoreManagement/PurchaseOrderDetail/PurchaseOrderDetail",
              code: "PurchaseOrderDetail:query",
              level: 2,
              authIndex: 90,
            },
            {
              menuName: "采购信息记录",
              path: "/StoreManagement/PurchaseInfoRecord/PurchaseInfoRecord",
              code: "PurchaseInfoRecord:query",
              level: 2,
              authIndex: 801,
            },
          ],
        },
        {
          menuName: "扫描管理",
          code: "ScanManagement",
          level: 1,
          children: [
            {
              menuName: "收货扫描",
              path: "/StoreManagement/ReceivingScan/ReceivingScanList",
              code: "ReceivingScan:query",
              level: 2,
              authIndex: 68,
            },
            {
              menuName: "生产过程扫描",
              path: "/ProductionManagement/ProductionScan/ProductionScanIndex",
              code: "ProductionScan:query",
              level: 2,
              authIndex: 24,
            },
            // {
            //   menuName: "上料验证扫描",
            //   path: "/ProductionManagement/LoadMaterialScan/LoadMaterialScanIndex",
            //   code: "LoadMaterialScan:query",
            //   level: 2,
            //   authIndex: 25,
            // },
            {
              menuName: "批量生产扫描",
              path: "/ProductionManagement/PlFinishScan/PlFinishScanIndex",
              code: "PlFinishScan:query",
              level: 2,
              authIndex: 27,
            },
            {
              menuName: "生产检验扫描",
              path: "/ProductionManagement/CheckOutScan/CheckOutScan",
              code: "CheckOutScan:query",
              level: 2,
              authIndex: 601,
            },
            // {
            //   menuName: "生产下料扫描",
            //   path: "/ProductionManagement/ProductionBlankScan/ProductionBlankScan",
            //   code: "ProductionBlankScan:query",
            //   level: 2,
            // },
            // {
            //   menuName: "喷涂链位扫描",
            //   path: "/ProductionManagement/SprayScan/SprayScan",
            //   code: "SprayScan:query",
            //   level: 2,
            // },
            {
              menuName: "出库单扫描",
              path: "/StoreManagement/OutStoreScan/OutStoreScanList",
              code: "OutStoreScan:query",
              level: 2,
              authIndex: 52,
            },
            {
              menuName: "领料出库",
              path: "/StoreManagement/OutStockTransferScan/OutStockTransferScanList",
              code: "OutStoreScan:query",
              level: 2,
              authIndex: 407,
            },
            {
              menuName: "领料确认",
              path: "/StoreManagement/OutStockTransferScan/OutStockTransferScanConfirm",
              code: "OutStoreScan:query",
              level: 2,
              authIndex: 408,
            },
            {
              menuName: "退料出库",
              path: "/StoreManagement/OutStockTransferBackScan/OutStockTransferBackScanList",
              code: "OutStoreScan:query",
              level: 2,
              authIndex: 409,
            },
            {
              menuName: "退料确认",
              path: "/StoreManagement/OutStockTransferBackScan/OutStockTransferBackScanConfirm",
              code: "OutStoreScan:query",
              level: 2,
              authIndex: 410,
            },
            // {
            //   menuName: "工单发料",
            //   path: "/StoreManagement/WorkOrderStoreIssue/WorkOrderStoreIssueList",
            //   code: "WorkOrderStoreIssue:query",
            //   level: 2,
            //   authIndex: 54,
            // },
            // {
            //   menuName: "工单发料扫描",
            //   path: "/StoreManagement/WorkOrderStoreIssueScan/WorkOrderStoreIssueScanList",
            //   code: "StoreIssue:query",
            //   level: 2,
            //   authIndex: 56,
            // },
            // {
            //   menuName: "生产入库",
            //   path: "/StoreManagement/ProductionStorage/ProductionStorageIndex",
            //   code: "ProductionStorage:query",
            //   level: 2,
            //   authIndex: 70,
            // },
            {
              menuName: "入库单扫描",
              path: "/StoreManagement/StoreScan/StoreScanList",
              code: "StoreScan:query",
              level: 2,
              authIndex: 89,
            },
            {
              menuName: "生产入库扫描",
              path: "/StoreManagement/ProductionStoreScan/ProductionStoreScanIndex",
              code: "ProductionStoreScan:query",
              level: 2,
              authIndex: 89,
            },
          ],
        },
        {
          menuName: "仓库管理",
          code: "StoreManagement",
          level: 1,
          children: [
            {
              menuName: "扫描记录",
              path: "/StoreManagement/ScanRecord/ScanRecordList",
              code: "ScanRecordList:query",
              level: 2,
              authIndex: 540,
            },
            {
              menuName: "库存明细",
              path: "/StoreManagement/Inventory/InventoryList",
              code: "Inventory:query",
              level: 2,
              authIndex: 31,
            },
            {
              menuName: "生产领料",
              path: "/StoreManagement/ProductionPicking/ProductionPickingList",
              code: "ProductionPicking:query",
              level: 2,
              authIndex: 33,
            },
            {
              menuName: "调拨领料",
              path: "/StoreManagement/OutStockTransferPicking/OutStockTransferPickingList",
              code: "ProductionPicking:query",
              level: 2,
              authIndex: 420,
            },
            {
              menuName: "生产退料",
              path: "/StoreManagement/ProductionReturn/ProductionReturnList",
              code: "ProductionReturn:query",
              level: 2,
              authIndex: 371,
            },
            {
              menuName: "领料单退料",
              path: "/StoreManagement/PickingReturn/PickingReturnList",
              code: "ProductionReturn:query",
              level: 2,
              authIndex: 371,
            },
            // {
            //   menuName: "销售出库",
            //   path: "/StoreManagement/OutStockDelivery/OutStockDeliveryList",
            //   code: "ProductionPicking:query",
            //   level: 2,
            //   authIndex: 298,
            // },
            {
              menuName: "销售出库",
              path: "/StoreManagement/OutStockDelivery/OutStockDeliveryDetailList",
              code: "OutStockDeliveryDetail:query",
              level: 2,
              authIndex: 298,
            },
            {
              menuName: "出库订单",
              path: "/StoreManagement/OutStockOrder/OutStockOrderList",
              code: "OutStockOrder:query",
              level: 2,
              authIndex: 43,
            },
            {
              menuName: "入库订单",
              path: "/StoreManagement/StorageOrder/StorageOrderIndex",
              code: "StorageOrder:query",
              level: 2,
              authIndex: 80,
            },
          ],
        },
        {
          menuName: "质量管理",
          code: "qm",
          level: 1,
          children: [
            {
              menuName: "测试记录",
              path: "/qm/InspectionTest/InspectionTestList",
              code: "InspectionTestList:query",
              level: 2,
              authIndex: 641,
            },
            {
              menuName: "首检巡检NG",
              path: "/qm/ProductNg/ProductNgList",
              code: "ProductNgList:query",
              level: 2,
              authIndex: 620,
            },
            {
              menuName: "巡检检验表",
              path: "/qm/InspectionReport1/InspectionReportList1",
              code: "InspectionReportList1:query",
              level: 2,
              authIndex: 528,
            },
            {
              menuName: "首件检验表",
              path: "/qm/InspectionReport/InspectionReportList",
              code: "InspectionReportList:query",
              level: 2,
              authIndex: 521,
            },
            {
              menuName: "来料NG",
              path: "/qm/PurchaseNg/PurchaseNgList",
              code: "PurchaseNgList:query",
              level: 2,
              authIndex: 615,
            },
            {
              menuName: "来料检验表",
              path: "/qm/PurchaseReport/PurchaseReportList",
              code: "PurchaseReportList:query",
              level: 2,
              authIndex: 446,
            },
            {
              menuName: "巡检检验模板",
              path: "/qm/ProductTemplate2/ProductTemplateList2",
              code: "ProductTemplateList2:query",
              level: 2,
              authIndex: 631,
            },
            {
              menuName: "首件检验模板",
              path: "/qm/ProductTemplate1/ProductTemplateList1",
              code: "ProductTemplateList1:query",
              level: 2,
              authIndex: 627,
            },
            {
              menuName: "来料检验模板",
              path: "/qm/PurchaseTemplate/PurchaseTemplateList",
              code: "PurchaseTemplateList:query",
              level: 2,
              authIndex: 516,
            },
            {
              menuName: "标准检验模板",
              path: "/qm/MaterialTemplate/MaterialTemplateList",
              code: "TemplateManagementList:query",
              level: 2,
              authIndex: 439,
            },
            {
              menuName: "检验项",
              path: "/information/Inspection/InspectionItemList",
              code: "ERP:query",
              level: 2,
              authIndex: 433,
            },
          ],
        },
        {
          menuName: "设备管理",
          code: "EquipmentManagement",
          level: 1,
          children: [
            {
              menuName: "设备档案",
              path: "/em/Equipment/EquipmentList",
              code: "Equipment:query",
              level: 2,
              authIndex: 452,
            },
            {
              menuName: "设备维修",
              path: "/em/EMRepairOrder/EMRepairOrderList",
              code: "EMRepairOrder:query",
              level: 2,
              authIndex: 459,
            },
            {
              menuName: "日期维护",
              path: "/em/EMRepairOrder/DataList",
              code: "DataList:query",
              level: 2,
              authIndex: 461,
            },
            {
              menuName: "维修子单",
              path: "/em/EMRepairOrderDetail/EMRepairOrderDetailList",
              code: "EMRepairOrderDetail:query",
              level: 2,
              authIndex: 457,
            },
          ],
        },
        {
          menuName: "治具管理",
          code: "ToolManagement",
          level: 1,
          children: [
            {
              menuName: "治具类型管理",
              path: "/information/ToolManagement/ToolType/ToolTypeTree",
              code: "ToolType:query",
              level: 2,
              authIndex: 472,
            },
            {
              menuName: "治具档案",
              path: "/information/ToolManagement/Tool/ToolList",
              code: "Tool:query",
              level: 2,
              authIndex: 472,
            },
            {
              menuName: "治具领用记录",
              path: "/information/ToolManagement/ToolRequisitionBill/ToolRequisitionBillList",
              code: "ToolRequisitionBill:query",
              level: 2,
              authIndex: 472,
            },
          ],
        },
        {
          menuName: "基本信息",
          code: "information",
          level: 1,
          children: [
            {
              menuName: "客户管理",
              path: "/information/Customer/CustomerList",
              code: "customer:query",
              level: 2,
              authIndex: 100,
            },
            {
              menuName: "客户物料关系",
              path: "/information/CustomerMaterialMapping/CustomerMaterialMappingList",
              code: "customerMaterialMapping:query",
              level: 2,
              authIndex: 106,
            },
            {
              menuName: "供应商管理",
              path: "/information/SupplierManage/SupplierManageList",
              code: "supplierManage:query",
              level: 2,
              authIndex: 111,
            },
            {
              menuName: "部门管理",
              path: "/information/Department/DepartmentList",
              code: "department:query",
              level: 2,
              authIndex: 113,
            },
            {
              menuName: "员工管理",
              path: "/information/Employee/EmployeeList",
              code: "employee:query",
              level: 2,
              authIndex: 118,
            },
            {
              menuName: "物料管理",
              path: "/information/Material/MaterialList",
              code: "material:query",
              level: 2,
              authIndex: 123,
            },
            {
              menuName: "物料类型管理",
              path: "/information/MaterialTypeName/MaterialTypeNameTree",
              code: "materialTypeName:query",
              level: 2,
              authIndex: 128,
            },
            {
              menuName: "BOM管理",
              path: "/information/BomManage/BomList",
              code: "bomManage:query",
              level: 2,
              authIndex: 134,
            },
            {
              menuName: "计量单位管理",
              path: "/information/Unit/UnitList",
              code: "unit:query",
              level: 2,
              authIndex: 141,
            },
            {
              menuName: "条码规则管理",
              path: "/information/BarCodeRules/BarCodeRulesList",
              code: "barCodeRules:query",
              level: 2,
              authIndex: 147,
            },
            {
              menuName: "客户条码管理",
              path: "/information/CustomerSnRule/CustomerSnRuleList",
              code: "customerSnRule:query",
              level: 2,
              authIndex: 152,
            },
            {
              menuName: "物料条码管理",
              path: "/information/MaterialSnRule/MaterialSnRuleList",
              code: "materialSnRule:query",
              level: 2,
              authIndex: 152,
            },
            {
              menuName: "区域管理",
              path: "/information/District/DistrictList",
              code: "district:query",
              level: 2,
              authIndex: 157,
            },
            {
              menuName: "工厂管理",
              path: "/information/Factory/FactoryList",
              code: "factory:query",
              level: 2,
              authIndex: 162,
            },
            {
              menuName: "车间管理",
              path: "/information/WorkShop/WorkShopList",
              code: "WorkShop:query",
              level: 2,
              authIndex: 168,
            },
            {
              menuName: "工作中心管理",
              path: "/information/WorkCenter/WorkCenterList",
              code: "WorkCenter:query",
              level: 2,
              authIndex: 174,
            },
            {
              menuName: "工作单元管理",
              path: "/information/WorkUnit/WorkUnitList",
              code: "WorkUnit:query",
              level: 2,
              authIndex: 180,
            },
            {
              menuName: "技能管理",
              path: "/information/Skill/SkillList",
              code: "Skill:query",
              level: 2,
              authIndex: 186,
            },
            {
              menuName: "工序类型管理",
              path: "/information/ProcessTypeManagement/ProcessTypeList",
              code: "ProcessTypeManagement:query",
              level: 2,
              authIndex: 109,
            },
            {
              menuName: "工序管理",
              path: "/information/Procedure/ProcedureList",
              code: "procedure:query",
              level: 2,
              authIndex: 205,
            },
            {
              menuName: "工艺路线管理",
              path: "/information/RtRoute/RtRouteList",
              code: "rtRoute:query",
              level: 2,
              authIndex: 212,
            },
            {
              menuName: "产品工艺管理",
              path: "/information/RtRouteMaterial/RtRouteMaterialList",
              code: "rtRouteMaterial:query",
              level: 2,
              authIndex: 219,
            },
            {
              menuName: "仓库配置",
              path: "/information/WarehouseNew/WarehouseList",
              code: "WarehouseNew:query",
              level: 2,
              authIndex: 227,
            },
            {
              menuName: "库区配置",
              path: "/information/WarehouseArea/WarehouseAreaList",
              code: "WarehouseArea:query",
              level: 2,
              authIndex: 901,
            },
            {
              menuName: "仓位配置",
              path: "/information/WarehouseLocation/WarehouseLocationList",
              code: "WarehouseLocation:query",
              level: 2,
              authIndex: 951,
            },
            {
              menuName: "载具配置",
              path: "/information/Vehicle/VehicleList",
              code: "vehicle:query",
              level: 2,
              authIndex: 245,
            },
            {
              menuName: "班组管理",
              path: "/information/WorkerGroup/WorkerGroupList",
              code: "workerGroup:query",
              level: 2,
              authIndex: 354,
            },
            {
              menuName: "项目管理",
              path: "/information/ProjectManagement/ProjectList",
              code: "ProjectManagement:query",
              level: 2,
              authIndex: 333,
            },
            {
              menuName: "任务管理",
              path: "/information/TaskManagement/TaskList",
              code: "TaskManagement:query",
              level: 2,
              authIndex: 335,
            },
            {
              menuName: "ERP数据管理",
              path: "/information/ERP/ErpOrderManage",
              code: "ERP:query",
              level: 2,
              authIndex: 431,
            },
          ],
        },
        {
          menuName: "看板管理",
          code: "spectaculars",
          level: 1,
          children: [
            {
              menuName: "生产看板",
              path: "/Spectaculars/Productpectaculars",
              code: "Productpectaculars:query",
              level: 2,
              authIndex: 502,
            },
            {
              menuName: "车间看板1",
              path: "/Spectaculars/Kb1",
              code: "Kb1:query",
              level: 2,
              authIndex: 502,
            },
            {
              menuName: "车间看板2",
              path: "/Spectaculars/Kb2",
              code: "Kb2:query",
              level: 2,
              authIndex: 502,
            },
            {
              menuName: "车间看板3",
              path: "/Spectaculars/Kb3",
              code: "Kb3:query",
              level: 2,
              authIndex: 502,
            },
            {
              menuName: "车间看板4",
              path: "/Spectaculars/Kb4",
              code: "Kb4:query",
              level: 2,
              authIndex: 502,
            },
            {
              menuName: "仓库看板",
              path: "/Spectaculars/Kb5",
              code: "Kb5:query",
              level: 2,
              authIndex: 502,
            },
            {
              menuName: "仓库收发料看板",
              path: "/Spectaculars/Kb6",
              code: "Kb6:query",
              level: 2,
              authIndex: 502,
            },
          ],
        },
        {menuName: "表单管理", code: "fm", level: 1, children: [
            {menuName: "新产品申请", path: "/fm/ProductionApplication/ProductionApplicationList", code: "role:query", level: 2, authIndex: 237,},
            {menuName: "供应商申请", path: "/fm/SupplierApplication/SupplierApplicationList", code: "role:query", level: 2, authIndex: 647},
          ],
        },
        {
          menuName: "系统管理",
          code: "system",
          level: 1,
          children: [
            {
              menuName: "角色管理",
              path: "/SystemInfo/role/RoleList",
              code: "role:query",
              level: 2,
              authIndex: 253,
            },
            {
              menuName: "表单分配",
              path: "/SystemInfo/WfConfig/WFConfigList",
              code: "profiles:query",
              level: 2,
              authIndex: 477,
            },
            {
              menuName: "用户管理",
              path: "/SystemInfo/SystemUser/UserList",
              code: "systemUser:query",
              level: 2,
              authIndex: 258,
            },
            {
              menuName: "个人信息",
              path: "/SystemInfo/profiles/ProfilesList",
              code: "profiles:query",
              level: 2,
              authIndex: 263,
            },
            {
              menuName: "菜单管理",
              path: "/SystemInfo/systemFunction/SystemFunctionTree",
              code: "systemFunction:query",
              level: 2,
              authIndex: 266,
            },
            {
              menuName: "系统字典",
              path: "/SystemInfo/systemDictionary/SystemDictionaryList",
              code: "systemDictionary:query",
              level: 2,
              authIndex: 270,
            },
            {
              menuName: "客户环境配置",
              path: "/SystemInfo/CustomerEnvironmentConfiguration/CustomerEnvironmentConfigurationList",
              code: "customerEnvironmentConfiguration:query",
              level: 2,
              authIndex: 275,
            },
            {
              menuName: "编码规则",
              path: "/SystemInfo/EncodingRules/EncodingRulesList",
              code: "encodingRules:query",
              level: 2,
              authIndex: 280,
            },
          ],
        },
      ],
      authMenus: [],
    };
  },
  mounted() {
    this.initMenu();
  },
  methods: {
    initMenu() {
      this.logoSrc = "../../../../img/se/print_logo.png";
      this.menus.forEach((item) => {
        if (item.level === 1) {
          item.children = (item.children || []).filter((child) => {
            if (child.authIndex instanceof Array) {
              for (let item of child.authIndex) {
                if (this.$auth(item)) {
                  return true;
                }
              }
              return false;
            } else {
              return this.$auth(child.authIndex);
            }
          });
          if (item.children.length > 0) {
            this.authMenus.push(item);
          }
        }
      });
      this.menusCopy = JSON.stringify(this.authMenus);
    },

    inputHandle() {
      var that = this;
      let indexs = [];
      let arr = JSON.parse(that.menusCopy);
      let newArr = [];
      if (that.menuName) {
        arr.forEach((item) => {
          if (item.children.length) {
            let result = item.children.filter((item) => item.menuName.indexOf(that.menuName.toUpperCase()) !== -1);
            if (result.length) {
              newArr.push(item);
              item.children = result;
            }
          }
        });
        that.authMenus = newArr;
        setTimeout(function() {
          if (that.authMenus.length) {
            that.authMenus.forEach((item) => {
              indexs.push(item.menuName);
            });
            that.defaultOpens = indexs;
          }
        }, 100);
      } else {
        that.authMenus = JSON.parse(that.menusCopy);
        that.defaultOpens = [];
      }
    },

    goto(menu) {
      this.$router.push({path: menu.path});
    },
  },
};
</script>

<style lang="scss">
@import "../../style/variables";
// 菜单展开样式
.vm-sidebar {
  width: $sidebar-width;
  background-color: #00101c;
  overflow: hidden;

  .logo {
    height: 50px;
    line-height: 50px;
    padding-left: 0px;
    color: #fff;
    font-size: 40px;
    font-weight: 700;
    letter-spacing: 1px;

    .el-badge__content.is-fixed {
      top: 30px;
      right: 0px;
      border: none;
    }
  }

  .el-scrollbar {
    height: 100%;

    .el-scrollbar__wrap {
      overflow-x: hidden;
    }
  }

  .el-menu {
    background-color: #00101c;
    border-right: 0;

    .el-submenu__title,
    .el-menu_item,
    .el-menu-item {
      color: #fff;
      height: 50px;
      line-height: 50px;

      &:hover {
        background-color: #3555cc;
      }

      border-bottom: 1px solid rgb(23, 25, 33);
    }

    .el-menu-item.is-active {
      background-color: #3555cc;
    }

    .is-opened ul {
      background-color: #000c17;
    }

    .el-menu-item {
      padding-left: 40px !important;
    }

    .el-submenu__title i {
      color: #fff;
      margin-right: 8px;
    }

    .el-icon-arrow-down {
      margin-top: -6px;
    }
  }
}

// 菜单收起样式
.vm-sidebar-close {
  width: $sidebar-width-close;

  .not-select,
  .el-submenu__icon-arrow {
    display: none;
  }

  .icon-lg {
    font-size: 20px;
  }

  .el-menu {
    border-right: none;
  }
}

.menuSearch {
  padding: 5px 10px 0 10px;
  margin-bottom: 5px;

  .el-input__inner {
    border-radius: 20px;
    background-color: #444;
    border: none;
    color: #fff;
  }
}
</style>
